import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export default class ReferralStatusView extends Enum {
  value!: string;
  color!: string;

  public static INVITED: ReferralStatusView = {
    get value() {
      return Lang.t('referral.referred');
    },
    color: '#1305b8'
  };

  public static NOT_INVITED: ReferralStatusView = {
    get value() {
      return Lang.t('referral.not-referred');
    },
    color: '#7E84A3'
  };
}
